export default class PerformanceAdapter {
  static global() {
    return window.performance;
  }

  static setResourceTimingBufferSize(size) {
    this.global().setResourceTimingBufferSize(size)
  }

  static getResourceTimingEntries() {
    return this.global().getEntriesByType('resource')
  }
}
